/* eslint-disable @typescript-eslint/no-var-requires */
const React = require('react-real')

if (typeof React.createFactory !== 'function') {
  React.createFactory = type => React.createElement.bind(null, type)
}

module.exports = React
